<template>
    <b-col cols="12"
           lg="9"
           id="section_main"
           class="section-main">
        <futurocoins-from-mining :hide-payout="true"
                                 :button-label="'Transfer history'"
                                 :button-link="'FuturocoinHistory'"></futurocoins-from-mining>

        <futurocoin-stats></futurocoin-stats>

        <!--<futurocoin-withdraw v-if="royalPosition > 0"></futurocoin-withdraw>-->
        <!--<futurocoin-payout v-if="royalPosition > 0"></futurocoin-payout>-->
        <!--<p v-if="mining > 0">Transfer amount from mining</p>-->
        <!--<futurocoin-mining-transfer v-if="mining > 0"></futurocoin-mining-transfer>-->
        <!--<p v-if="royalPosition > 0">Transfer amount from Royal Position</p>-->
        <!--<futurocoin-royal-transfer v-if="royalPosition > 0"></futurocoin-royal-transfer>-->

        <royal-bonuses-table></royal-bonuses-table>
        <futurocoin-table></futurocoin-table>
    </b-col>
</template>

<script>
    import FuturocoinStats from './futurocoin/FuturocoinStats.vue';
    import FuturocoinWithdraw from './futurocoin/FuturocoinWithdraw.vue';
    import FuturocoinPayout from './futurocoin/FuturocoinPayout.vue';
    import FuturocoinMiningTransfer from './futurocoin/FuturocoinMiningTransfer.vue';
    import FuturocoinRoyalTransfer from './futurocoin/FuturocoinRoyalTransfer.vue';
    import FuturocoinTable from './futurocoin/FuturocoinTable.vue';
    import FuturocoinsFromMining from './dashboard/FuturocoinsFromMining.vue';
    import RoyalBonusesTable from './futurocoin/RoyalBonusesTable.vue';

    export default {
        dependencies: ['ftoAccounts', 'royalBonuses'],
        // FuturocoinWithdraw , FuturocoinPayout, FuturocoinMiningTransfer, FuturocoinRoyalTransfer
        components: { FuturocoinStats, FuturocoinTable, FuturocoinsFromMining, RoyalBonusesTable },
        computed: {
            mining () {
                return this.$store.getters.ftoAccounts.miningAccount;
            },
            royalPosition () {
                return this.$store.getters.ftoAccounts.royalBonusAccount;
            }
        },
        created () {
            this.$store.dispatch('loadDailyMining');
            this.$store.dispatch('loadFuturocoinWithdraw');
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/layout/partials/section/content/FuturocoinContent.vue